import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import { createDropdownItemByValueAndText } from 'utils/reactSemanticUtils';
import {
  APPEND_KYB_DETAIL_ERROR_MESSAGES,
  SET_KYB_APPROVAL_LOGS,
  SET_KYB_APPROVE_CONFIRM_MODAL_LOADING,
  SET_KYB_APPROVE_CONFIRM_MODAL_SHOWN,
  SET_KYB_BUSINESS_DETAIL_LOADING_STATE,
  SET_KYB_BUSINESSES_LIST,
  SET_KYB_DETAIL_BANK_ACCOUNT,
  SET_KYB_DETAIL_BUSINESS_DETAILS,
  SET_KYB_DETAIL_ERROR_MESSAGES,
  SET_KYB_DETAIL_KTP_DETAILS,
  SET_KYB_DETAIL_MODAL_SHOWN,
  SET_KYB_EDIT_BANK_ACCOUNT_MODAL_LOADING,
  SET_KYB_EDIT_BANK_ACCOUNT_MODAL_SHOWN,
  SET_KYB_EDIT_KTP_MODAL_LOADING,
  SET_KYB_EDIT_KTP_MODAL_SHOWN,
  SET_KYB_LIST_FILTERS,
  SET_KYB_LIST_IS_LOADING,
  SET_KYB_REJECT_CONFIRM_MODAL_LOADING,
  SET_KYB_REJECT_CONFIRM_MODAL_SHOWN,
  SET_KYB_REVIEW_DETAILS_MODAL_LOADING,
  SET_KYB_REVIEW_DETAILS_MODAL_SHOWN,
} from 'state/actionTypes';

const businessListFilterInitialState = {
  startCreatedDate: null,
  endCreatedDate: null,
  kybStatus: 'all',
  searchKeyword: '',
  isKybRegistrationCompleted: true,
  kybStatusOptions: [
    createDropdownItemByValueAndText('all', 'All'),
    createDropdownItemByValueAndText('pending', 'Waiting for Approval'),
    createDropdownItemByValueAndText('approved', 'Approved'),
    createDropdownItemByValueAndText('rejected', 'Rejected'),
  ],
};

const businessListFilters = createReducer(businessListFilterInitialState, {
  [SET_KYB_LIST_FILTERS]: (state, { payload }) => ({ ...state, ...payload }),
});

const businessesListInitialState = {
  list: [],
  page: 1,
  size: 20,
  total: 0,
};

const businessListIsLoading = createReducer(false, {
  [SET_KYB_LIST_IS_LOADING]: (state, { payload }) => payload,
});

const businesses = createReducer(businessesListInitialState, {
  [SET_KYB_BUSINESSES_LIST]: (state, { payload }) => payload,
});

const businessDetailInitialState = {
  business: null,
  modalShown: false,
  loadingStates: {
    business: false,
    ktp: false,
    bankAccount: false,
    log: false,
  },
  errorMessages: [],
  ktp: null,
  bankAccount: null,
  approveModal: {
    shown: false,
    isLoading: false,
  },
  approvalLogs: {
    last_log: null,
    logs: [],
  },
  rejectModal: {
    shown: false,
    isLoading: false,
  },
  editBankAccountModal: {
    shown: false,
    isLoading: false,
  },
  reviewDetailsModal: {
    shown: false,
    isLoading: false,
  },
  editKtpModal: {
    shown: false,
    isLoading: false,
  },
};

const businessDetail = createReducer(businessDetailInitialState, {
  [SET_KYB_DETAIL_MODAL_SHOWN]: (state, { payload }) => ({
    ...state,
    modalShown: payload,
  }),
  [SET_KYB_DETAIL_BUSINESS_DETAILS]: (state, { payload }) => ({
    ...state,
    business: payload.business,
  }),

  [APPEND_KYB_DETAIL_ERROR_MESSAGES]: (state, { payload }) => ({
    ...state,
    errorMessages: [...(state.errorMessages || []), ...payload.messages],
  }),
  [SET_KYB_DETAIL_ERROR_MESSAGES]: (state, { payload }) => ({
    ...state,
    errorMessages: payload.messages,
  }),
  [SET_KYB_BUSINESS_DETAIL_LOADING_STATE]: (state, { payload }) => ({
    ...state,
    loadingStates: {
      ...state.loadingStates,
      ...payload.loadingStates,
    },
  }),
  [SET_KYB_DETAIL_KTP_DETAILS]: (state, { payload }) => ({
    ...state,
    ktp: payload.ktp,
  }),
  [SET_KYB_DETAIL_BANK_ACCOUNT]: (state, { payload }) => ({
    ...state,
    bankAccount: payload.bankAccount,
  }),

  [SET_KYB_APPROVE_CONFIRM_MODAL_LOADING]: (state, { payload }) => ({
    ...state,
    approveModal: {
      ...state.approveModal,
      isLoading: payload.isLoading,
    },
  }),
  [SET_KYB_APPROVE_CONFIRM_MODAL_SHOWN]: (state, { payload }) => ({
    ...state,
    approveModal: {
      ...state.approveModal,
      shown: payload.shown,
    },
  }),

  [SET_KYB_APPROVAL_LOGS]: (state, { payload }) => ({
    ...state,
    approvalLogs: payload.approvalLogs,
  }),

  [SET_KYB_REJECT_CONFIRM_MODAL_SHOWN]: (state, { payload }) => ({
    ...state,
    rejectModal: {
      ...state.rejectModal,
      shown: payload.shown,
    },
  }),
  [SET_KYB_REJECT_CONFIRM_MODAL_LOADING]: (state, { payload }) => ({
    ...state,
    rejectModal: {
      ...state.rejectModal,
      isLoading: payload.isLoading,
    },
  }),

  [SET_KYB_EDIT_BANK_ACCOUNT_MODAL_SHOWN]: (state, { payload }) => ({
    ...state,
    editBankAccountModal: {
      ...state.editBankAccountModal,
      shown: payload.shown,
    },
  }),
  [SET_KYB_EDIT_BANK_ACCOUNT_MODAL_LOADING]: (state, { payload }) => ({
    ...state,
    editBankAccountModal: {
      ...state.editBankAccountModal,
      isLoading: payload.isLoading,
    },
  }),

  [SET_KYB_REVIEW_DETAILS_MODAL_SHOWN]: (state, { payload }) => ({
    ...state,
    reviewDetailsModal: {
      ...state.reviewDetailsModal,
      shown: payload.shown,
    },
  }),
  [SET_KYB_REVIEW_DETAILS_MODAL_LOADING]: (state, { payload }) => ({
    ...state,
    reviewDetailsModal: {
      ...state.reviewDetailsModal,
      isLoading: payload.isLoading,
    },
  }),

  [SET_KYB_EDIT_KTP_MODAL_SHOWN]: (state, { payload }) => ({
    ...state,
    editKtpModal: {
      ...state.editKtpModal,
      shown: payload.shown,
    },
  }),
  [SET_KYB_EDIT_KTP_MODAL_LOADING]: (state, { payload }) => ({
    ...state,
    editKtpModal: {
      ...state.editKtpModal,
      isLoading: payload.isLoading,
    },
  }),
});

export default combineReducers({
  businesses: combineReducers({
    data: businesses,
    filters: businessListFilters,
    isLoading: businessListIsLoading,
  }),
  businessDetail,
});
